import classNames from 'classnames';
import { BsChevronRight } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { setView } from '@/actions/pdp.actions';
import { PDPViews } from '@types';

const PartnerDesignGallery = ({ className = '' }) => {
  const dispatch = useAppDispatch();
  const { miyo } = useSelector((state: any) => state.pdpItem);

  if (!miyo?.partnerConfig?.partner) return null;

  const imageUrl = miyo?.partnerConfig?.partner?.galleryUrl;
  const onClick = () => {
    dispatch(setView(PDPViews.ASSET_PREVIEW));
  };

  return (
    <div className={classNames(className)}>
      <div>
        <p className='tw:mt-4 tw:mb-4 tw:text-sm tw:font-normal'>
          Select from other designs in the Design Gallery.
        </p>
        <div
          className={classNames(
            'tw:flex tw:w-full tw:cursor-pointer tw:items-center tw:bg-white tw:justify-between tw:gap-3 tw:rounded-button tw:border tw:border-neutrals-light-grey tw:py-2 tw:px-4 tw:text-body tw:transition tw:duration-300 tw:hover:border-neutrals-medium-grey'
          )}
          onClick={onClick}>
          <div className='tw:inline-flex tw:items-center tw:gap-4'>
            <div className='tw:inline-flex tw:h-[45px] tw:w-[55px] tw:items-center tw:justify-center'>
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt={`${miyo?.partnerConfig?.partner?.description} Logo`}
                  className='tw:max-h-full tw:max-w-full'
                />
              )}
            </div>
            <p className='tw:mb-0 tw:text-base tw:font-bold tw:uppercase tw:text-body'>Design Gallery</p>
          </div>

          <BsChevronRight size={16} className='tw:text-body' />
        </div>
      </div>
    </div>
  );
};

export default PartnerDesignGallery;
